import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PublicScanSourcePage } from '@brand24-original/llm-types';
import ReportSection from './ReportSection';
import './ReportSourcePages.scss';

interface ReportSourcePagesProps {
  pages: PublicScanSourcePage[];
}

export const ReportSourcePages: React.FC<ReportSourcePagesProps> = ({ pages }) => {
  const { t } = useTranslation();

  // Slajd bez danych w ogóle nie wchodzi do raportu — ani na stronie, ani w PDF.
  if (pages.length === 0) {
    return null;
  }

  return (
    <ReportSection
      title={t('reportPagesTitle')}
      titleAccent={t('reportPagesTitleAccent')}
      subtitle={t('reportPagesSubtitle')}
    >
      <ol className="report-pages">
        {pages.map((page, index) => (
          <li
            key={page.url}
            className={`report-pages__card${page.isTrackedDomain ? ' report-pages__card--tracked' : ''}`}
          >
            <span className="report-pages__rank">{index + 1}</span>

            <div className="report-pages__main">
              <a
                className="report-pages__title"
                href={page.url}
                target="_blank"
                rel="noopener noreferrer nofollow"
                title={page.title ?? page.url}
              >
                {page.title ?? page.url}
              </a>
              <span className="report-pages__url" title={page.url}>
                {page.url}
              </span>
              <div className="report-pages__track">
                {/* Pełna skala 0-100% — pasek pokazuje udział w CAŁOŚCI cytowań. */}
                <div className="report-pages__bar" style={{ width: `${Math.min(page.share, 100)}%` }} />
              </div>
            </div>

            {/* Liczba cytowań ustępuje miejsca udziałowi po najechaniu na kafel. */}
            <span className="report-pages__value">
              <span className="report-pages__citations">{page.citations}</span>
              <span className="report-pages__share">{page.share}%</span>
            </span>
          </li>
        ))}
      </ol>
    </ReportSection>
  );
};

export default ReportSourcePages;
